import React from 'react';
import { Link } from 'react-router-dom';

/**
 * PublicPageFooter component for footer/public pages
 * Provides consistent footer across all public pages
 */
const PublicPageFooter = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-100 py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          {/* Product */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Product</h3>
            <ul className="space-y-2">
              <li><Link to="/pricing" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">Pricing</Link></li>
              <li><Link to="/integrations" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">Integrations</Link></li>
              <li><Link to="/docs/features" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">Features</Link></li>
            </ul>
          </div>
          
          {/* Documentation */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Documentation</h3>
            <ul className="space-y-2">
              <li><Link to="/docs" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">Docs Home</Link></li>
              <li><Link to="/docs/getting-started" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">Getting Started</Link></li>
              <li><Link to="/docs/personal" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">Personal Workspace</Link></li>
              <li><Link to="/docs/organization" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">Organization Workspace</Link></li>
              <li><Link to="/docs/admin" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">Admin & Permissions</Link></li>
            </ul>
          </div>
          
          {/* Company */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">Contact</Link></li>
            </ul>
          </div>
          
          {/* Support */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Support</h3>
            <ul className="space-y-2">
              <li><Link to="/help" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">Help Center</Link></li>
              <li><Link to="/privacy" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-200 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center space-x-3">
              <img src="/icon.png" alt="Tasklina" className="w-6 h-6" />
              <span className="text-sm text-gray-500">© 2025 Tasklina. All rights reserved.</span>
            </div>
            <div className="flex items-center space-x-6">
              <Link to="/privacy" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">
                Privacy
              </Link>
              <Link to="/terms" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">
                Terms
              </Link>
              <Link to="/contact" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">
                Contact
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicPageFooter;
